module.exports = __webpack_public_path__ + "static/media/favicon.e962e1f4.ico";